import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

export const MainCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 24px;
  gap: 16px;
  border-bottom: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    padding: 0 0 20px;
  `)}
`;

export const TopSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TopRightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.p`
  ${Typography.body_md_semibold}
  color: var(--text-secondary);
  margin: 0;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
  }
  :hover {
    border-radius: var(--border-radius-8);
    background: var(--neutral-secondary);
    svg {
      fill: var(--text-primary);
    }
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const Title = styled.div`
  ${Typography.body_md}
  color:var(--text-primary);
`;
